import { render, staticRenderFns } from "@/style-guide/partials/search/search.pug?vue&type=template&id=295f3f87&scoped=true&lang=pug&external"
import script from "./search.vue?vue&type=script&lang=ts"
export * from "./search.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295f3f87",
  null
  
)

export default component.exports